import { BadgeButton, BadgeProps } from "src/components/base/badges/base";
import React from "react";
import { useLocation } from "@tanstack/react-router";

export type GroupBadgeProps = {
    /**
     * The group this badge is for
     *
     * The type is intentionally not from the generated sdk
     * to support as many caller as possible
     */
    group: { uuid: string; name: string; description?: string };

    /** Optional color to use instead of the default (`"blue"`) */
    color?: BadgeProps["color"];

    /** Additional classname to set */
    className?: string;
};

export function GroupBadge(props: GroupBadgeProps) {
    const location = useLocation();
    const href = location.href.startsWith("/c") ? "/c/groups/$groupId/general" : "/a/groups/$groupId/general";

    return (
        <BadgeButton
            className={props.className}
            color={props.color ?? "blue"}
            href={href}
            params={{ groupId: props.group.uuid }}
            title={props.group.description}
        >
            {`group:${props.group.name}`}
        </BadgeButton>
    );
}
